<script setup>
import ErrorMessage from '@/components/widgets/ErrorMessage.vue';

const emit = defineEmits(['retry']);
defineProps({
    hideRetryButton: {
        type: Boolean,
        default: false
    },
    message: {}
});
</script>

<template>
    <ErrorMessage :show="true" :message="message" @retry="emit('retry')">
        <span v-if="!hideRetryButton">
            <br />
            <v-btn
                @click="emit('retry')"
                variant="outlined"
                class="mt-2"
                prepend-icon="mdi-sync"
            >
                {{ $t('Try again') }}
            </v-btn>
        </span>
    </ErrorMessage>
</template>
